import { GetPlanResponseSchema, type GetPlanResponse } from '@weft/api-definition';
import type { WeftApi } from '@weft/client';
import type { Replace } from '@weft/utils';
import { isNotNullOrUndefined, validateNotEmptyObject } from '@weft/utils';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomBaseUseQueryOptions,
  CustomUseQueryOptions, CustomUseQueryOptionsWithoutSuspense,
  CustomUseQueryOptionsWithSuspense } from './requests-types/custom-use-query-options';

export function usePlanByIdOptions(planId: string, api: WeftApi = getPrivateApi()): CustomBaseUseQueryOptions<GetPlanResponse> {
  return {
    queryKey: ['plan', planId],
    suspense: true,
    queryFn: async () => {
      const getPlanResponse = await api.getPlan({ planId });

      return GetPlanResponseSchema.parse(getPlanResponse);
    },
  };
}

export function usePlanById(planId: string, options?: CustomUseQueryOptionsWithSuspense<GetPlanResponse>): Replace<UseQueryResult<GetPlanResponse>, 'data', GetPlanResponse>;
export function usePlanById(planId: string, options?: CustomUseQueryOptionsWithoutSuspense<GetPlanResponse>): UseQueryResult<GetPlanResponse>;
export function usePlanById(planId: string, options?: CustomUseQueryOptions<GetPlanResponse>): UseQueryResult<GetPlanResponse> | Replace<UseQueryResult<GetPlanResponse>, 'data', GetPlanResponse> {
  const plansApi = getPrivateApi();
  const suspense = options?.suspense ?? true;

  const planQuery = useQuery(
    ['plan', planId],
    async () => {
      const getPlanResponse = await plansApi.getPlan({ planId });

      return GetPlanResponseSchema.parse(getPlanResponse);
    },
    {
      enabled: isNotNullOrUndefined(planId),
      ...options,
      suspense,
    });

  if (suspense) {
    validateNotEmptyObject(planQuery.data, `Plan with id ${planId}`);
  }

  return planQuery;
}